import React from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import RuleOfConduct from './RuleOfConduct';
import ButtonNext from './ButtonNext';
import {publicBuildUrl} from '../../config/config';

const RulesOfConduct = ({hasNextButton = false}) => (
    <Page title={'Start or resume'}>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: '1080px',
        }}>
            <div style={styles.title}>Spelregels</div>
            <div className={'bodyContainer'} style={{width: '100%', paddingLeft: 0, paddingRight: 0}}>
                <div className={'bodyContainerColumn'} style={styles.row}>
                    <RuleOfConduct alt={'Respect'} icon={`${publicBuildUrl}icons/IconRespect.png`} text={'Heb respect voor elkaar.'}/>
                    <RuleOfConduct alt={'Luister'} icon={`${publicBuildUrl}icons/IconListen.png`} text={'Luister naar elkaar en laat elkaar uitpraten.'}/>
                    <RuleOfConduct alt={'Stilte'} icon={`${publicBuildUrl}icons/IconSilence.png`} text={'Wanneer de animatie wordt afgespeeld is iedereen stil.'}/>
                    <RuleOfConduct alt={'Reageren'} icon={`${publicBuildUrl}icons/IconRaiseHand.png`} text={'Steek je hand op als je iets wil vragen of ergens op wil reageren.'}/>
                </div>
                <div className={'bodyContainerColumn'} style={{
                    ...styles.row,
                    position: 'relative',
                }}>
                    <RuleOfConduct alt={'Spreekbaar'} icon={`${publicBuildUrl}icons/IconNegotiable.png`} text={'Als je iets over jezelf bespreekbaar wil maken dan kun je dit na de les doen. Het is belangrijk dat hier de tijd voor genomen kan worden en dat kan niet tijdens de les.'}/>
                    <RuleOfConduct alt={'Dialoog'} icon={`${publicBuildUrl}icons/IconDialogue.png`} text={'Bespreek samen wat je kunt doen als het even niet gaat en houd je hieraan.'}/>
                    <RuleOfConduct alt={'GSM'} icon={`${publicBuildUrl}icons/IconMobile.png`} text={'Zet je telefoon op stil en heb hem alleen in je handen als daar om gevraagd wordt.'}/>

                    {hasNextButton && <div style={styles.nextContainer}>
                        <ButtonNext navigateDeviceNext={false}/>
                    </div>}
                </div>
            </div>
        </div>
    </Page>
);

RuleOfConduct.propTypes = {
    hasNextButton: PropTypes.bool,
}

const styles = {
    row: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContents: 'flex-start',
    },
    nextContainer: {
        position: 'absolute',
        bottom: -100,
        right: 50,
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        fontStyle: 'italic',
        lineHeight: '48px',
        paddingBottom: '25px',
        marginBottom: '25px',
        width: '100%',
    },
}

export default RulesOfConduct;
